module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('header-top'), _vm._v(" "), _c('div', {
    staticClass: "recommend-img-wrap",
    style: ({
      width: _vm.templateWidth + 'px'
    })
  }, _vm._l((_vm.imgJson), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "recommend-img-box"
    }, _vm._l((item.imgArr), function(itm, idx) {
      return _c('div', {
        key: idx,
        style: ({
          width: (100 / item.imgArr.length) + '%'
        })
      }, [(itm.jumpType == '1') ? _c('img', {
        staticClass: "recommend-img",
        attrs: {
          "src": itm.imgSrc,
          "alt": ""
        }
      }) : _vm._e(), _vm._v(" "), (itm.jumpType == '2') ? _c('router-link', {
        attrs: {
          "tag": "a",
          "target": "_blank",
          "to": {
            name: 'Detail',
            query: {
              goodsId: itm.goodsId
            }
          }
        }
      }, [_c('img', {
        staticClass: "recommend-img",
        attrs: {
          "src": itm.imgSrc,
          "alt": ""
        }
      })]) : _vm._e(), _vm._v(" "), (itm.jumpType == '3') ? _c('a', {
        attrs: {
          "href": itm.href,
          "target": "_blank"
        }
      }, [_c('img', {
        staticClass: "recommend-img",
        attrs: {
          "src": itm.imgSrc,
          "alt": ""
        }
      })]) : _vm._e()], 1)
    }), 0)
  }), 0), _vm._v(" "), (_vm.showModel == '2') ? _c('div', {
    staticClass: "category-goods-wrap main-width recommend-wrap"
  }, [_c('ul', {
    staticClass: "category-goods-list"
  }, _vm._l((_vm.goodsObj.goodsList), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "category-goods-item"
    }, [_c('div', {
      staticClass: "category-goods-image"
    }, [_c('router-link', {
      attrs: {
        "tag": "a",
        "target": "_blank",
        "to": {
          name: 'Detail',
          query: {
            goodsId: item.appGoodsVo.goodsId
          }
        }
      }
    }, [_c('div', {
      staticClass: "recommend-image",
      style: ({
        backgroundImage: 'url(' + _vm.imgAddress + item.appGoodsVo.goodsImage + ')'
      })
    }), _vm._v(" "), _c('div', {
      staticClass: "category-cover-image",
      class: {
        a: item.appGoodsVo.isBill == 1
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "category-hover-product"
    }, [_c('table', {
      attrs: {
        "border": "0",
        "cellspacing": "0",
        "cellpadding": "0"
      }
    }, [_c('thead', [_c('tr', [_c('th', [_vm._v("SKU")]), _vm._v(" "), _c('th', [(item.appGoodsVo.isBill == 0) ? _c('span', [_vm._v("\n                                不带票结算价\n                                "), (item.appGoodsVo.supplyChannel == 1) ? _c('span', [_vm._v("(+运费)")]) : _vm._e()]) : _c('span', [_vm._v("\n                                带票结算价\n                                "), (item.appGoodsVo.supplyChannel == 1) ? _c('span', [_vm._v("(+运费)")]) : _vm._e()])]), _vm._v(" "), _c('th', [_vm._v("库存")])])]), _vm._v(" "), _c('tbody', _vm._l((item.appGoodsVo.products), function(itm, idx) {
      return (idx < 7) ? _c('tr', {
        key: idx
      }, [_c('td', {
        staticClass: "category-table-SKU"
      }, [_c('div', [_vm._v(_vm._s(itm.specName))])]), _vm._v(" "), _c('td', [(item.appGoodsVo.isBill == 0) ? _c('span', [_vm._v("\n                                " + _vm._s(itm.settlementPrice / 100) + "\n                                "), (item.appGoodsVo.supplyChannel == 1) ? _c('span', {
        staticClass: "freight-price"
      }, [_vm._v("(+" + _vm._s(itm.freight / 100) + ")")]) : _vm._e()]) : _c('span', [_vm._v("\n                                " + _vm._s(itm.settlementPrice / 100) + "\n                                "), (item.appGoodsVo.supplyChannel == 1) ? _c('span', {
        staticClass: "freight-price"
      }, [_vm._v("(+" + _vm._s(itm.freight / 100) + ")")]) : _vm._e()])]), _vm._v(" "), _c('td', [(item.appGoodsVo.isBill == 0) ? _c('span', [_vm._v(_vm._s(itm.inventoryNum))]) : _c('span', [_vm._v(_vm._s(itm.inventoryNum))])])]) : _vm._e()
    }), 0)])])])], 1), _vm._v(" "), _c('div', {
      staticClass: "category-goods-info"
    }, [_c('el-tooltip', {
      staticClass: "item",
      attrs: {
        "effect": "dark",
        "content": item.appGoodsVo.goodsName,
        "placement": "top"
      }
    }, [_c('div', {
      staticClass: "category-goods-title2"
    }, [_vm._v("\n                      " + _vm._s(item.appGoodsVo.goodsName) + "\n                    ")])]), _vm._v(" "), _c('div', {
      staticClass: "category-goods-type"
    }, [(
      item.appGoodsVo.supplyChannel == 2 || item.appGoodsVo.supplyChannel == 3
    ) ? _c('div', [_vm._v("\n                      社群集采\n                    ")]) : _vm._e(), _vm._v(" "), (item.appGoodsVo.supplyChannel == 1) ? _c('div', [_vm._v("一件代发")]) : _vm._e(), _vm._v(" "), (item.appGoodsVo.isSelf == 1) ? _c('div', {
      staticStyle: {
        "background-color": "rgb(231, 249, 235)",
        "color": "rgb(88, 191, 106)"
      }
    }, [_vm._v("\n                      自产自销\n                    ")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "category-goods-price2"
    }, [_c('div', [_vm._v("\n                      结算价\n                      "), _c('span', [_vm._v("\n                        ¥\n                        "), _c('span', {
      staticStyle: {
        "font-size": "18px"
      }
    }, [_vm._v(_vm._s(item.appGoodsVo.originSettlementPrice / 100))])])]), _vm._v(" "), _c('div', [_vm._v("\n                      毛利率 ¥\n                      " + _vm._s((
      ((item.appGoodsVo.salePrice - item.appGoodsVo.settlementPrice) /
        item.appGoodsVo.salePrice) *
      100
    ).toFixed(2) + "%") + "\n                    ")])]), _vm._v(" "), _c('div', {
      staticClass: "category-goods-price3"
    }, [_c('div', [_vm._v("建议零售价 ¥ " + _vm._s(item.appGoodsVo.salePrice / 100))]), _vm._v(" "), _c('div', [_vm._v("\n                      毛利 ¥\n                      "), _c('span', {
      staticStyle: {
        "color": "#ff6015"
      }
    }, [_vm._v(_vm._s((item.appGoodsVo.salePrice - item.appGoodsVo.settlementPrice).toFixed(2) /
      100))])])])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
      attrs: {
        "span": 12
      }
    }, [(item.appGoodsVo.shelves == 0) ? _c('div', {
      staticClass: "category-goods-add-default",
      on: {
        "click": function($event) {
          return _vm.addNewShelves(item)
        }
      }
    }, [_vm._v("\n                    加入货架\n                  ")]) : _c('div', {
      staticClass: "category-goods-add-default yishangjia"
    }, [_vm._v("\n                    已加入货架\n                  ")])]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 12
      }
    }, [(true) ? _c('el-tooltip', {
      staticClass: "item",
      attrs: {
        "effect": "dark",
        "content": "添加商品报价至报价篮子，可以批量导出商品报价",
        "placement": "top"
      }
    }, [_c('div', {
      staticClass: "get-price",
      on: {
        "click": function($event) {
          return _vm.getPrice(index, item.appGoodsVo.goodsId)
        }
      }
    }, [_vm._v("获取报价")])]) : _vm._e(), _vm._v(" "), (false) ? _c('el-tooltip', {
      staticClass: "item",
      attrs: {
        "effect": "dark",
        "content": "该商品已添加至“报价篮子”，可以前往“报价篮子”导出报价！",
        "placement": "top"
      }
    }, [_c('div', {
      staticClass: "get-price yet"
    }, [_vm._v("已添加报价")])]) : _vm._e()], 1)], 1)], 1)
  }), 0)]) : _vm._e(), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "",
      "visible": _vm.dialogVisible,
      "width": "600px"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("成功添加商品到“报价篮子”，可以前往“报价篮子”批量导出商品报价！")]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('div', {
    staticClass: "category-goods-add-default",
    staticStyle: {
      "width": "200px",
      "margin": "0 auto"
    },
    on: {
      "click": function($event) {
        _vm.dialogVisible = false
      }
    }
  }, [_vm._v("我知道了")])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2b9c7f2a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Recommend.vue
// module id = 524
// module chunks = 1